module.exports = __webpack_public_path__ + "img/w24-cover.b13afe3e.jpg";